<template>
  <div
    class="relative group w-40 h-40 max-w-full max-h-full rounded-full flex flex-wrap self-center overflow-hidden"
    :class="{ 'cursor-pointer': edit }"
    @click="edit ? upload() : false"
  >
    <div
      v-if="edit"
      class="absolute z-20 inset-0 w-full h-full opacity-25 hover:opacity-75 flex justify-center align-center p-16 transition-opacity duration-200 cursor-pointer overflow-hidden rounded-full"
    >
      <icon name="Edit" size="100%" />
    </div>
    <div class="w-full h-full z-10 flex">
      <img
        class="w-full h-full self-end object-cover"
        :src="avatar"
        v-if="avatar"
        :class="{ 'opacity-50 group-hover:opacity-25 transition-opacity duration-200': edit }"
      />
      <div class="w-full h-full flex items-center justify-center text-center text-white" v-else>
        <icon name="Profile" size="2.5em" :settings="{strokeWidth:'1', circle: false}" />
      </div>
    </div>
    <div
      class="absolute inset-0 rounded-full bg-primary-200 z-0 transition-colors duration-200"
      v-if="bg"
    />
  </div>
</template>

<script>
export default {
  name: "Avatar",
  data() {
    return {};
  },
  props: {
    avatar: {
      default: null,
      type: String
    },
    edit: {
      default: false,
      type: Boolean
    },
    bg: {
      default: true,
      type: Boolean
    }
  },
  components: {},
  methods: {
    upload() {
      this.$emit("upload");
    }
  },
  computed: {},
  async created() {}
};
</script>
